import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswFreeSoftwareTrialState {
}

export default {
  state : {},
  actions: {
    getFreeSoftwareTrails(context: ActionContext<MswFreeSoftwareTrialState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const url = 'firmware/get-software-free-trials';
      return ApiServiceWrapper.get(url);
    },
  },
  namespaced: true,
} as Module<MswFreeSoftwareTrialState, RootStoreState>;
